import { Controller } from 'stimulus';
import morphdom from 'morphdom';
import RequestQueue from '../classes/RequestQueue';
import MitreTable from "../utils/mitre-table";

class TableAggregateRowController extends Controller {

  initialize() {
    const tableKey = this.element.closest('[data-table-key-value]').getAttribute('data-table-key-value');
    this._mitreTable = MitreTable.getByTableKey(tableKey);

    this.tableDom = this.element.closest('.m-table');
  }

  connect() {
    this._handleTableAggregateRowUpdate = () => this._updateRow();

    this._mitreTable.on('table-aggregate-row-update', this._handleTableAggregateRowUpdate);
  }

  disconnect() {
    this._mitreTable.removeListener('table-aggregate-row-update', this._handleTableAggregateRowUpdate);
  }

  async _updateRow() {
    const { currentTabKey, theme, collectionKey, defaultFilters } = this._mitreTable.getParams();
    try {
      const response = await RequestQueue.addToQueue({
        url: '/api/t/agg.html/',
        method: 'post',
        data: {
          uuid: this._mitreTable.tableKey,
          tab: currentTabKey,
          theme,
          default_filters: defaultFilters,
          collection: collectionKey
        }
      });
      const { data } = response;
      const parser = new DOMParser();
      // // get existing element
      const prev = this.element;
      // // create the new element
      const fragment = parser.parseFromString(data, 'text/html').body;
      // // render on screen - update the DOM
      const result = morphdom(prev, fragment);
      morphdom(result, result.firstChild);

      this._mitreTable.on('table-agg-row-update-complete');
    } catch (e) {
      // continue regardless of error
    }
  }
}

export default TableAggregateRowController;
